export enum ParametersList {
	FraudeVirements = 'FRAUDEVIREMENTS'
}